import VideoCard from "./Cards/VideoCard";
import EmbedCard from "./Cards/EmbedCard";
import ImageCard from "./Cards/ImageCard";

import { IFeedEntry } from "../store/FeedEntry";

export default function CardType({
  hideEntry,
  index,
  feedEntry,
  height,
}: {
  hideEntry: Function;
  index: number;
  feedEntry: IFeedEntry;
  height: "100vh" | "80vh";
}) {
  if (feedEntry && feedEntry.type === "video") {
    return <VideoCard feedEntry={feedEntry} />;
  } else if (feedEntry && feedEntry.type === "embed") {
    return <EmbedCard feedEntry={feedEntry} />;
  } else if (feedEntry !== undefined) {
    return (
      <ImageCard height={height} hideEntry={hideEntry} index={index} feedEntry={feedEntry} />
    );
  }
  return <div></div>;
}
